const mockData = {
  firstName: 'Thomas',
  todayScore: [
    {
      score: 30,
    },
    {
      score: 70,
    },
  ],
  keyData: {
    calorieCount: 1930,
    proteinCount: 155,
    carbohydrateCount: 290,
    lipidCount: 50,
  },
  activity: [
    {
      day: '1',
      kilogram: 80,
      calories: 350,
    },
    {
      day: '2',
      kilogram: 79,
      calories: 220,
    },
    {
      day: '3',
      kilogram: 78,
      calories: 280,
    },
    {
      day: '4',
      kilogram: 77,
      calories: 290,
    },
    {
      day: '5',
      kilogram: 76,
      calories: 160,
    },
    {
      day: '6',
      kilogram: 76,
      calories: 162,
    },
    {
      day: '7',
      kilogram: 78,
      calories: 390,
    },
  ],
  average: [
    {
      day: 'L',
      sessionLength: 45,
    },
    {
      day: 'M',
      sessionLength: 30,
    },
    {
      day: 'M',
      sessionLength: 45,
    },
    {
      day: 'J',
      sessionLength: 15,
    },
    {
      day: 'V',
      sessionLength: 20,
    },
    {
      day: 'S',
      sessionLength: 50,
    },
    {
      day: 'D',
      sessionLength: 60,
    },
  ],
  perf: [
    {
      type: 'Cardio',
      score: 80,
    },
    {
      type: 'Énergie',
      score: 120,
    },
    {
      type: 'Endurance',
      score: 140,
    },
    {
      type: 'Force',
      score: 50,
    },
    {
      type: 'Vitesse',
      score: 200,
    },
    {
      type: 'Intensité',
      score: 90,
    },
  ],
}

export default mockData
